import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const ToTop16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M12.7461 6.92535L12.7451 6.9243L8.57068 2.71237C8.41147 2.52311 8.20279 2.44202 8.00036 2.44202C7.79783 2.44202 7.59286 2.52249 7.43474 2.68294L3.25531 6.92464C2.92808 7.25968 2.9133 7.81341 3.22314 8.16431C3.53617 8.52054 4.05942 8.53118 4.3867 8.19749L8.00031 4.53041L11.6139 8.20031C11.9419 8.53443 12.4633 8.52122 12.7773 8.16645C13.0856 7.81412 13.0725 7.26063 12.7461 6.92535Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.7461 11.9833L12.7451 11.9823L8.57068 7.77036C8.41147 7.58109 8.20279 7.5 8.00036 7.5C7.79783 7.5 7.59286 7.58048 7.43474 7.74092L3.25531 11.9826C2.92808 12.3177 2.9133 12.8714 3.22314 13.2223C3.53617 13.5785 4.05942 13.5892 4.3867 13.2555L8.00031 9.58839L11.6139 13.2583C11.9419 13.5924 12.4633 13.5792 12.7773 13.2244C13.0856 12.8721 13.0725 12.3186 12.7461 11.9833Z"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
